require('slick-carousel-latest');
$(() => {
	const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('slide') && urlParams.has('tab')) {
        const sliderIndex = urlParams.get('slide');
        const tabIndex = urlParams.get('tab');
        const $slider = $('[data-slick]').eq(sliderIndex);
        $slider.slick('slickGoTo', tabIndex);
        $('html, body').animate({
            scrollTop: $slider.closest('.container').offset().top - ($('header').outerHeight() + 5)
        }, 1500);
    }
});
